import React from "react"
import { Link } from "gatsby"
import "./content.css"
import "./component.css"
import "./emailcontactus-content.css"
import { TiggbeePartnerContent } from "./tiggbee-partners-content"

export class SchoolpageContent extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      isOnVideoPlayMode: false,
    }
  }

  renderCareerPart = () => {
    const element = (
      <>
        <div className="content-section-container">
          <div className="title">
            Impactful Career Awareness & Exploration
          </div>
          <div className="description">
            Tiggbee is a fast, fun and free career discovery platform.
          </div>
          <br />
          <br />
          <div className="grid-layout-container" style={{ alignItems: 'flex-start' }}>
            <div className="paraph-group-container">
              <p>
                Tiggbee enables every student in your school district to connect with inspiring role models, guest speakers, and businesses—earning career readiness hours with purpose through engaging, interactive 5-minute weekly video events.
              </p>
              <p>
                Our platform brings careers to life, helping students—from 4th grade through graduation—explore diverse industries, understand what it takes to succeed, and map out their educational path with intention.
              </p>
              <p>
                Unlike other platforms, Tiggbee gives educators full control over content, ensuring a safe, focused, and impactful experience in every classroom.
              </p>
              <br />
              <div className="button-group" style={{ justifyContent: "flex-start" }}>
                <Link to="/contact-us-page">
                  Contact Us
                </Link>
                <div className="description">
                  (It's Free!)
                </div>
              </div>
            </div>
            <div className="video-container">
              <div className="title"><div>Buzzworthy Watch</div></div>
              <video
                controls
                id='WatchTiggbeeInAction'
                preload='metadata'
                poster='https://tiggbeeweb6b99bab7c47b48e7820368aded133811-dev.s3.us-west-2.amazonaws.com/public/public-files/Tiggbee+In+Action+Thumbnail.png'
              >
                <source
                  src='https://d3luynq40dfrpk.cloudfront.net/public/public-files/Tiggbee+In+Action.mp4'
                  type="video/mp4"
                />
              </video>
              <div className="description">
                <br />
                <div><b>1,133,800 hours</b> of Work-Based Learning</div>
                <div>Experience and counting</div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
    return element;
  }

  renderMadeForSchoolsPart = () => {
    const madeForSchoolsList = [
      {
        icon: "made-for-school-icon1.png",
        titleElement: (<>WE BRING INDUSTRY<br />TO YOU IN just<br />5-MINUTE EPISODES</>),
      },
      {
        icon: "made-for-school-icon2.png",
        titleElement: (<>SEAMLESSLY FITS INTO<br />ADVISORY, HOMEROOM,<br />4TH-12<super>TH</super> GRADE CLASSES</>),
      },
      {
        icon: "made-for-school-icon3.png",
        titleElement: (<>INTERACTIVE EVENTS<br />AND VIRTUAL job<br />SHADOWS</>),
      },
      {
        icon: "made-for-school-icon4.png",
        titleElement: <>IT'S FREE</>
      },
      {
        icon: "made-for-school-icon5.png",
        titleElement: (<>BREAKS<br />ECONOMIC<br />BARRIERS</>),
      },
      {
        icon: "made-for-school-icon6.png",
        titleElement: (<>BREAKS<br />GEOGRAPHIC<br />BARRIERS</>),
      },
      {
        icon: "made-for-school-icon7.png",
        titleElement: (<>CORRELATES STUDIES<br />TO OPPORTUNITIES<br />+STUDENT REPORTS</>),
      },
      {
        icon: "made-for-school-icon8.png",
        titleElement: (<>IT'S SAFE AND<br />ALIGNS WITH CAREER<br />READINESS STANDARDS</>)
      },
    ];
    const element = (
      <>
        <div className="content-section-container" style={{ background: "linear-gradient(135deg, rgba(255, 253, 243, 0.93) 0%, rgba(255, 222, 89, 0.95) 50%, #ff9b05)" }}>
          <div className="title">
            Built for Students. Powered by Industry.
          </div>
          <br />
          <div className="white-table-image-container" style={{ marginTop: "-15px", marginBottom: "-30px" }}>
            <img alt="" src="/school-build-banner.png" />
          </div>
          <br />
          <div className="table-container white-table">
            <div className="row">
              {madeForSchoolsList.map((item, index) => (
                <div className="column col-6 col-md-3" key={index}>
                  <div className="icon-list-item">
                    <img alt="" src={`/${item.icon}`} />
                    <div>{item.titleElement}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </>
    );
    return element
  }

  renderQuotaPart = () => {
    const element = (
      <>
        <div className="content-section-container" style={{ paddingTop: "72px", paddingBottom: "72px" }}>
          <div className="table-container white-table" style={{ padding: "0px", marginTop: "0px", marginBottom: "0px" }}>
            <div className="row">
              <div className="col-12 col-lg-2 col-xl-1">
                <div className="quota-icon">
                  <img alt="" src="/quota-icon.png" />
                </div>
              </div>
              <div className="col-12 col-lg-4 col-xl-5">
                <div className="paraph-group-container" style={{ fontStyle: "italic", textAlign: "justify" }}>
                  <p style={{ lineHeight: '36px' }}>
                    “It’s truly remarkable that it’s completely free, and our students enjoy it immensely. It provides excellent exposure to different careers and enhances their overall education.” — Dylan L., Vice Principal, NY
                  </p>
                  <p style={{ lineHeight: '36px', marginBottom: "0px" }}>
                    Tiggbee is very useful. Helps my 8th graders to ‘think out of the box.’ — Sybil, Middle School Teacher, VA
                  </p>
                </div>
              </div>
              <div className="col-12 col-lg-2 col-xl-1" />
              <div className="col-12 col-lg-4 col-xl-5">
                <div className="paraph-group-container" style={{ fontStyle: "italic", textAlign: "justify" }}>
                  <p style={{ lineHeight: '36px', marginBottom: "0px" }}>
                    My students love to see if their question makes it into the response video. Before I play the video, I go over the information on the person and the salaries under the other tabs. I also find local jobs in our area so we can compare the job descriptions and the salaries. Thanks for providing us with a virtual opportunity to explore jobs. — Laura, High School Teacher, VA
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
    return element
  }

  renderEasyPart = () => {
    const element = (
      <>
        <div className="content-section-container">
          <div className="title">
            Easy to Start. Easy to Stick with.
          </div>
          <div className="grid-layout-container">
            <div className="icon-list" style={{ marginTop: "24px" }}>
              <div><div>🗓️</div>Free 30-minute training available</div>
              <div><div>🔌</div>Integrates with Clever, ClassLink, Google</div>
              <div><div>🆓</div>100% free for schools, grades K–12</div>
              <div><div>🛡️</div>Safe, secure, and ad-free</div>
              <div><div>✅</div>No Prep Required: Skip the guest speaker logistics</div>
            </div>
          </div>
        </div>
      </>
    );
    return element;
  }

  render() {
    const html = (
      <>
        {this.renderCareerPart()}
        {this.renderMadeForSchoolsPart()}
        {this.renderQuotaPart()}
        <TiggbeePartnerContent />
        {this.renderEasyPart()}
      </>
    )
    return html
  }
}
